import { QuillDangerousInnerHTML } from './chunk-AJTPMSEI.mjs';
import { cn } from '@flexmr/ui';
import { jsx } from 'react/jsx-runtime';

function HTMLAnswerText({
  children,
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    QuillDangerousInnerHTML,
    {
      className: cn("mb-0 inline-block [&_p]:mx-0", className),
      ...props,
      children
    }
  );
}

export { HTMLAnswerText };
//# sourceMappingURL=chunk-ZB6PYWMQ.mjs.map
//# sourceMappingURL=chunk-ZB6PYWMQ.mjs.map